<template>
  <div class="calc-root">
    <transition name="fade">
      <div v-if="widguservis">
        <WidgUser />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="widgcalcvis" class="calc-wrapper">
        <div class="calc-card">
          <!-- Header -->
          <div class="calc-header">
            <div class="calc-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4a7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="4" y="2" width="16" height="20" rx="2" />
                <line x1="8" y1="6" x2="16" y2="6" />
                <line x1="8" y1="10" x2="10" y2="10" />
                <line x1="14" y1="10" x2="16" y2="10" />
                <line x1="8" y1="14" x2="10" y2="14" />
                <line x1="14" y1="14" x2="16" y2="14" />
                <line x1="8" y1="18" x2="10" y2="18" />
                <line x1="14" y1="18" x2="16" y2="18" />
              </svg>
            </div>
            <h4 class="calc-title">Payment Calculator</h4>
            <p class="calc-subtitle">Customize your plan and see your payment instantly</p>
          </div>

          <!-- Estimate input -->
          <div class="calc-field">
            <label class="calc-label">Repair Estimate</label>
            <div class="calc-input-wrap">
              <span class="calc-input-prefix">$</span>
              <input
                ref="Estimate"
                v-model="calcinput"
                type="number"
                class="calc-input"
                :class="{
                  'calc-input--valid': calcinput >= 500 && calcinput <= 10000,
                  'calc-input--error': calcinput && (calcinput < 500 || calcinput > 10000)
                }"
                placeholder="0.00"
              />
            </div>
            <div v-if="calcinput && calcinput > 10000" class="calc-hint calc-hint--error">Maximum $10,000</div>
            <div v-else-if="calcinput && calcinput < 500 && calcinput > 0" class="calc-hint calc-hint--error">Minimum $500</div>
          </div>

          <!-- Term selector -->
          <div class="calc-field">
            <label class="calc-label">Loan Term</label>
            <div class="calc-term-grid">
              <button
                v-for="opt in options"
                :key="opt.value"
                class="calc-term-btn"
                :class="{ 'calc-term-btn--active': selected === opt.value }"
                @click="selected = opt.value; selectedPlan()"
              >
                {{ opt.text }}
              </button>
            </div>
          </div>

          <!-- Payment display -->
          <div class="calc-payment-display">
            <div class="calc-payment-kicker">Your payment</div>
            <div class="calc-payment-amount">${{ updatedPayment }}</div>
            <div class="calc-payment-freq">{{ currentFrequencyLabel }}</div>
          </div>

          <!-- Frequency selector -->
          <div class="calc-field">
            <label class="calc-label">Payment Frequency</label>
            <div class="calc-freq-grid">
              <button
                v-for="opt in payOptions"
                :key="opt.value"
                class="calc-freq-btn"
                :class="{ 'calc-freq-btn--active': poSelected === opt.value }"
                @click="poSelected = opt.value; selectedPlan()"
              >
                {{ opt.text }}
              </button>
            </div>
          </div>

          <!-- CTA -->
          <button
            class="calc-btn"
            :disabled="!calcinput || calcinput < 500 || calcinput > 10000"
            @click="submit"
          >
            Continue
          </button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
import Loading from './loading'

let timeout = null

export default {
  name: 'NewCalc',
  components: {
    Loading,
  },
  data() {
    return {
      step: 3,
      title: 'Your payment would be',
      seen: false,
      visible: false,
      cashStatus: false,
      widgcalcvis: true,
      widguservis: false,
      poSelected: 'semimonthly',
      selected: 'radio3',
      options: [
        {
          text: '6 Months',
          value: 'radio1',
        },
        {
          text: '12 Months',
          value: 'radio2',
        },
        {
          text: '24 Months',
          value: 'radio3',
        },
        {
          text: '36 Months',
          value: 'radio4',
        },
      ],
      payOptions: [
        {
          text: 'Monthly',
          value: 'monthly',
        },
        {
          text: 'Semi Monthly',
          value: 'semimonthly',
        },
        {
          text: 'Bi-Weekly',
          value: 'biweekly',
        },
        {
          text: 'Weekly',
          value: 'weekly',
        },
      ],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      frequencyOfPayments: ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'],
      amount: '1650',
      paymentType: '3',
      paymentTypeButton: false,
      repairOfferAmount: '1650',
      updatedPayment: '45',
      fees: '87',
      rate: '14.9',
      term: '24',
      vendorOfUser: '',
      calcinput: 1650,
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
    }
  },

  watch: {
    calcinput() {
      const localThis = this
      if (this.calcinput < 10001 && this.calcinput > 499) {
        localThis.repairOfferAmount = localThis.calcinput
        console.log('this is repairofferamount' + localThis.repairOfferAmount)
        if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          // 12 months and Semi monthly [3,12]
          localThis.calculatePayment.call(this, [3, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [2, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [2, 6])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [3, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [0, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [1, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [0, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [0, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [1, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [1, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [1, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [1, 12])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [0, 12])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [1, 24])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [1, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [0, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [0, 24])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [1, 6])
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
    // The new function
    paymentTypeButton() {
      this.selectedPlan()
    },
  },
  computed: {
    currentFrequencyLabel() {
      const found = this.payOptions.find(o => o.value === this.poSelected)
      return found ? found.text : ''
    },
  },
  mounted() {
    this.repairOfferAmount = this.$store.state.userData.repairOfferAmount
    this.calcinput = this.$store.state.userData.repairOfferAmount
  },
  created() {
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.trunc(
      this.$store.state.userData.marketValue * 0.3 * 0.7 * this.loanRatio
    )
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan

    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount =
      this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.payment = this.calcPayment
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    // is the below line important?
    this.$store.state.userData.paymentPeriod = `${this.term} months`
    this.$store.state.userData.term = this.term
  },
  methods: {
    closereseize() {
      if ('parentIFrame' in window) window.parentIFrame.size(70)
      return false
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(409)
      return false
    },
    closeWin() {
      return [(this.widgcalcvis = false), (this.visible = true)]
    },
    next() {
      this.$store.state.userData.paymentMethod = this.paymentMethod
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    // Two function for the spinner
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    focusInput() {
      this.$refs.Estimate.focus()
    },
    next() {
      this.$store.state.userData.selectedRepair = this.selectedRepair
    },
    submit() {
      this.$store.state.userData.payment = parseFloat(this.updatedPayment) || 500
      this.$store.state.userData.loanRequested = this.repairOfferAmount
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.paymentPeriod = this.term
      this.$store.state.step = 4
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    test() {
      console.log('working')
    },
    /**
     * Compute max allowable fees so effective APR ≤ 27.9 %.
     * Returns the lesser of standard fees ($87) and the APR-safe maximum.
     */
    getAdjustedFees(loanAmount, numpayments, freqFactor) {
      const standardFees = parseFloat(this.fees)
      const aprCap = 27.9
      const nomRate = parseFloat(this.rate) || 14.9
      const P = loanAmount
      if (P <= 0 || numpayments <= 0) return standardFees

      const rAPR = aprCap / (freqFactor * 12) / 100
      const rNom = nomRate / (freqFactor * 12) / 100
      if (rAPR <= 0 || rNom <= 0) return standardFees

      const n = numpayments
      const powA = Math.pow(1 + rAPR, n)
      const powN = Math.pow(1 + rNom, n)
      if (powA === 1 || powN === 1) return standardFees

      const maxGross = P * (rAPR * powA / (powA - 1)) / (rNom * powN / (powN - 1))
      const maxFees = Math.max(0, Math.round((maxGross - P) * 100) / 100)
      return Math.min(standardFees, maxFees)
    },
    calculatePayment(pType) {
      this.term = pType[1]
      if (pType[1] === 6) {
        var myThis = this
        this.$store.state.userData.paymentPeriod = pType[1]
        console.log('is this logged ' + this.$store.state.userData.paymentPeriod)
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
        console.log('calculateP repair offer amount' + myThis.repairOfferAmount)
        const amount = myThis.repairOfferAmount
        const interest = myThis.rate
        const numpayments = pType[1] * paymentPeriod[pType[0]]
        // ── Adjust fees so effective APR ≤ 27.9 % ──
        let fees = this.getAdjustedFees(parseFloat(amount), numpayments, paymentPeriod[pType[0]])
        // 6-month term with amount < $1000: cap at admin fee ($39), but never above APR-safe max
        if (parseFloat(amount) < 1000) fees = Math.min(39, fees)
        this.fees = fees  // write back so downstream (PrincipalAmount etc.) uses capped value
        const rate = parseFloat(interest) / (paymentPeriod[pType[0]] * 12) / 100
        const aprRate = parseFloat(27.9) / (paymentPeriod[pType[0]] * 12) / 100
        const allPayments = parseFloat(amount) + parseFloat(fees)
        let totalmonthlypayment =
          (parseFloat(amount) * aprRate * Math.pow(1 + aprRate, numpayments)) /
          (Math.pow(1 + aprRate, numpayments) - 1)
        const noFeesMonthlyPayment =
          (allPayments * rate * Math.pow(1 + rate, numpayments)) /
          (Math.pow(1 + rate, numpayments) - 1)
        if (noFeesMonthlyPayment > totalmonthlypayment) {
          totalmonthlypayment = noFeesMonthlyPayment
        }
        const paymentFees = totalmonthlypayment - noFeesMonthlyPayment

        this.$store.state.userData.numberOfPayments = numpayments
        console.log('is this' + this.$store.state.userData.numberOfPayments)
        this.$store.state.userData.paymentFees = paymentFees.toFixed(2)
        console.log('fees' + this.$store.state.userData.paymentFees)
        myThis.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment
        this.$store.state.userData.repairOfferAmount = myThis.repairOfferAmount
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount
        console.log('before issue')
        // Set the payment period in the store
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
      } else {
        var myThis = this
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
        const amount = myThis.repairOfferAmount
        const interest = myThis.rate
        const numpayments = pType[1] * paymentPeriod[pType[0]]
        // ── Adjust fees so effective APR ≤ 27.9 % ──
        const fees = this.getAdjustedFees(parseFloat(amount), numpayments, paymentPeriod[pType[0]])
        this.fees = fees  // write back so downstream (PrincipalAmount etc.) uses capped value
        console.log('nmpayment' + numpayments)
        const rate = parseFloat(interest) / (paymentPeriod[pType[0]] * 12) / 100
        const aprRate = parseFloat(27.9) / (paymentPeriod[pType[0]] * 12) / 100
        console.log('apr rate' + aprRate)
        console.log('amount' + amount)
        const allPayments = parseFloat(amount) + parseFloat(fees)
        let totalmonthlypayment =
          (parseFloat(amount) * aprRate * Math.pow(1 + aprRate, numpayments)) /
          (Math.pow(1 + aprRate, numpayments) - 1)
        const noFeesMonthlyPayment =
          (allPayments * rate * Math.pow(1 + rate, numpayments)) /
          (Math.pow(1 + rate, numpayments) - 1)
        if (noFeesMonthlyPayment > totalmonthlypayment) {
          totalmonthlypayment = noFeesMonthlyPayment
        }
        const paymentFees = totalmonthlypayment - noFeesMonthlyPayment
        console.log('total monthly payment' + totalmonthlypayment)
        console.log('noFeesMonthlyPayment' + noFeesMonthlyPayment)
        console.log(paymentFees)
        this.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.paymentPeriods = numpayments
        this.$store.state.userData.numberOfPayments = pType[1]
        this.$store.state.userData.paymentFees = paymentFees.toFixed(2)
        console.log('fees to charge ' + this.$store.state.userData.paymentFees)
        this.$store.state.userData.loanApr = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment.toFixed(2)
        console.log('New Regular payment: ' + totalmonthlypayment.toFixed(2))
        this.$store.state.userData.invoiceBeforeTax = (myThis.repairOfferAmount / 1.12).toFixed(2)
        console.log('invoice before tax: ' + this.$store.state.userData.invoiceBeforeTax)
        this.$store.state.userData.PrincipalAmount = myThis.repairOfferAmount * 1 + myThis.fees * 1
        console.log('Principal Amount: ' + this.$store.state.userData.PrincipalAmount)
        this.$store.state.userData.newAPR = (1 * totalmonthlypayment).toFixed(4)
        console.log('New APR ' + this.$store.state.userData.newAPR)
        this.$store.state.userData.vendorToPay = (
          ((1 * myThis.repairOfferAmount) / 1.12) *
          1.05
        ).toFixed(2)
        console.log('Vendor topay: ' + this.$store.state.userData.vendorToPay)
        if (paymentPeriod[pType[0]] === 1 || paymentPeriod[pType[0]] === 2) {
          var paydate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 3)
          this.$store.state.userData.firstPaymentDay = paydate
        } else {
          var myThis = this
          var today = new Date()
          today.setDate(today.getDate() + ((12 - today.getDay()) % 7))
          this.$store.state.userData.firstPaymentDay = today
        }
        var myThis = this
        console.log('first payment date ' + this.$store.state.userData.firstPaymentDay)
        console.log('Number of Payments' + numpayments)
        this.$store.state.userData.totalPayments = this.$store.state.userData.payment * numpayments
        console.log('Total Payments: ' + this.$store.state.userData.totalPayments)
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount
        console.log('Repair Amount: ' + this.$store.state.userData.loanRequested)
        this.$store.state.userData.costOfFinancing = (
          1 * this.$store.state.userData.totalPayments -
          1 * myThis.repairOfferAmount
        ).toFixed(2)
        console.log('Repair Cost of Financing: ' + this.$store.state.userData.costOfFinancing)
        this.$store.state.userData.frequencyText = myThis.frequencyOfPayments[pType[0]]
        console.log('The frequency is: ' + this.$store.state.userData.frequencyText)
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
      }
    }, // close calculate payment function
    selectedPlan() {
      const localThis = this
      // const paymentPeriod = [4.34524, 2.17262, 2, 1]
      console.log('calcinput' + this.calcinput)
      console.log('radio' + this.selected)
      if (this.calcinput < 10001 && this.calcinput > 499) {
        console.log('true')
        this.repairOfferAmount = this.calcinput
        let paymentParams
        if (this.poSelected === 'monthly') {
          if (this.selected === 'radio1') {
            paymentParams = [3, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [3, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [3, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [3, 36]
          }
        } else if (this.poSelected === 'semimonthly') {
          if (this.selected === 'radio1') {
            paymentParams = [2, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [2, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [2, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [2, 36]
          }
        } else if (this.poSelected === 'biweekly') {
          if (this.selected === 'radio1') {
            paymentParams = [1, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [1, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [1, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [1, 36]
          }
        } else if (this.poSelected === 'weekly') {
          if (this.selected === 'radio1') {
            paymentParams = [0, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [0, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [0, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [0, 36]
          }
        }

        if (paymentParams) {
          this.calculatePayment.call(this, paymentParams)
        }
      } else if (this.calcinput > 10000) {
        console.log('true')

        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        console.log('true')

        this.updatedPayment = '500 Min.'
      }
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

/* ── Root ── */
.calc-root {
  font-family: 'Inter', sans-serif;
}

/* ── Wrapper ── */
.calc-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 12px;
}

/* ── Card ── */
.calc-card {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.07);
  padding: 32px 28px 28px;
}

/* ── Header ── */
.calc-header {
  text-align: center;
  margin-bottom: 22px;
}

.calc-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calc-title {
  font-weight: 700;
  font-size: 20px;
  color: #1e2a3a;
  margin: 0 0 4px;
  text-transform: none;
}

.calc-subtitle {
  font-size: 13px;
  color: #8a94a6;
  margin: 0;
}

/* ── Fields ── */
.calc-field {
  margin-bottom: 18px;
}

.calc-label {
  font-size: 11px;
  font-weight: 700;
  color: #5a6478;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 6px;
  display: block;
}

/* ── Input ── */
.calc-input-wrap {
  position: relative;
}

.calc-input-prefix {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  font-weight: 700;
  color: #b0b7c3;
  pointer-events: none;
}

.calc-input {
  width: 100%;
  padding: 14px 16px 14px 36px;
  border-radius: 14px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  color: #1e2a3a;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.calc-input:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

.calc-input--valid {
  border-color: #34d399;
}

.calc-input--valid:focus {
  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.15);
}

.calc-input--error {
  border-color: #f87171;
}

.calc-input--error:focus {
  box-shadow: 0 0 0 3px rgba(248, 113, 113, 0.15);
}

.calc-hint {
  font-size: 11px;
  font-weight: 600;
  margin-top: 5px;
  padding-left: 2px;
}

.calc-hint--error {
  color: #ef4444;
}

/* Hide number arrows */
.calc-input[type='number']::-webkit-inner-spin-button,
.calc-input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.calc-input[type='number'] {
  -moz-appearance: textfield;
}

/* ── Term buttons ── */
.calc-term-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.calc-term-btn {
  padding: 10px 4px;
  border-radius: 12px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  color: #5a6478;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: center;
  white-space: nowrap;
}

.calc-term-btn:hover {
  border-color: #4a7cff;
  color: #4a7cff;
  background: #f0f4ff;
}

.calc-term-btn--active {
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 4px 14px rgba(74, 124, 255, 0.3);
}

.calc-term-btn--active:hover {
  color: #fff;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
}

/* ── Payment display ── */
.calc-payment-display {
  text-align: center;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  border-radius: 16px;
  padding: 24px 16px;
  margin-bottom: 18px;
}

.calc-payment-kicker {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.calc-payment-amount {
  font-size: 42px;
  font-weight: 800;
  color: #fff;
  line-height: 1.1;
}

.calc-payment-freq {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
}

/* ── Frequency buttons ── */
.calc-freq-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.calc-freq-btn {
  padding: 9px 4px;
  border-radius: 10px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 11px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  color: #5a6478;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: center;
  white-space: nowrap;
}

.calc-freq-btn:hover {
  border-color: #34d399;
  color: #059669;
  background: #ecfdf5;
}

.calc-freq-btn--active {
  background: #ecfdf5;
  color: #059669;
  border-color: #34d399;
  font-weight: 700;
}

/* ── CTA button ── */
.calc-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s, opacity 0.2s;
  margin-top: 6px;
}

.calc-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(74, 124, 255, 0.25);
}

.calc-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.calc-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Misc ── */
.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
  left: 0;
}

/* ── Transitions ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .calc-card {
    padding: 24px 16px 22px;
    border-radius: 18px;
  }

  .calc-term-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .calc-freq-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .calc-payment-amount {
    font-size: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new_calc.vue